export default async({ store, next }) => {
  store.dispatch('setRightSidebarVisibility', true);
  next();
};
